export const keyBy = (array: any[], key: string) =>
  (array || []).reduce((r, x) => ({ ...r, [key ? x[key] : x]: x }), {});

export const groupBy = (array: any[], key: string) =>
  (array || []).reduce((acc, item) => {
    const groupKey = getNestedValue(item, key);
    if (!acc[groupKey]) {
      acc[groupKey] = [];
    }
    acc[groupKey].push(item);
    return acc;
  }, {});

function getNestedValue<T extends Record<string, any>>(obj: T, key: string): any {
  return key.split('.').reduce((acc, curr) => acc && acc[curr], obj);
}
